import { useCallback, useEffect, useState } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'
import {
  MemberEntityTypeKey,
  MemberProfileExtendedType,
} from 'common/types/MemberProfile'

interface GetExtendedProfileProps {
  id: string
  memberEntity: MemberEntityTypeKey
  reloadKey: number // increment this to refetch the profile
}

function getProfileNameToDisplay(profile: MemberProfileExtendedType): string {
  return profile.core.last_name && profile.core.first_name
    ? `${profile.core.first_name} ${profile.core.last_name}`
    : profile.core.practice_name
    ? profile.core.practice_name
    : profile.core.chamber_name
    ? profile.core.chamber_name
    : profile.core.organisation_name
}

const getApiPath = (memberEntity: MemberEntityTypeKey, id: string): string => {
  const entity =
    memberEntity === 'lawfirm'
      ? 'organisation'
      : memberEntity === 'solicitor'
      ? 'lawyers'
      : memberEntity.toLowerCase() + 's'

  const apiPath = `${Project.liveApi}legal-services/${entity}/extended-profile/${id}`
  const userLocation = localStorage.getItem('userLocation')

  if (userLocation) {
    const { latitude, longitude } = JSON.parse(userLocation)
    return `${apiPath}?consent=true&lat=${latitude}&lng=${longitude}`
  }
  return apiPath
}

export const useGetExtendedProfile = ({
  id,
  memberEntity,
  reloadKey,
}: GetExtendedProfileProps) => {
  const [extendedProfile, setExtendedProfile] =
    useState<MemberProfileExtendedType>(null)

  const loadExtendedProfile = useCallback(() => {
    _data
      .get(getApiPath(memberEntity, id))
      .then((result: MemberProfileExtendedType) => {
        const displayName = getProfileNameToDisplay(result)
        result['displayName'] = displayName ? displayName : 'Name not provided'
        result['memberEntity'] = memberEntity
        result.metadata.distance = Math.round(result.metadata.distance)
        setExtendedProfile(result)
      })
      .catch((error) => {
        console.error(
          'Failed to load extended profile:',
          error,
          id,
          memberEntity,
        )
      })
  }, [id, memberEntity])

  useEffect(() => {
    if (id && memberEntity) {
      loadExtendedProfile()
    }
  }, [id, memberEntity, loadExtendedProfile, reloadKey])

  return {
    extendedProfile,
    loadExtendedProfile,
  }
}